import { DashboardLink, ImagePicker, Inputs } from '@components'
import Switch from '@components/common/Switch/Switch'
import { ROUTES } from '@constants'
import { SummaryDashboard } from '@types'
import React, { FC } from 'react'
import { Controller } from 'react-hook-form'

type AdminDashboardFormProps = {
  summaryDashboard: SummaryDashboard
  isAllowUpdateStatus?: boolean
  onClearImage: () => void
  handleSubmit: () => void
  validateInputImage: (e) => void
}

const AdminDashboardForm: FC<AdminDashboardFormProps> = ({
  isAllowUpdateStatus,
  handleSubmit,
  summaryDashboard,
  validateInputImage,
  onClearImage,
}) => {
  const dashboardName = summaryDashboard.name || 'Dashboard Name'
  const dashboardImage = summaryDashboard.image
  const dashboardId = summaryDashboard.id
  const dashboardUrl = `${window.location.origin}${ROUTES.ADMIN_DASHBOARD.DASHBOARD}?dashboardId=${dashboardId}`

  return (
    <React.Fragment>
      <div className='head'>{dashboardName}</div>
      <div className='content'>
        <div className='box'>
          <div className='box-logo'>
            <div className='text-logo'>Dashboard Logo</div>
            <div className='text-size-picture'>
              Maximum image 1 MB.
              <br /> Allowed file types: png, jpg, jpeg.
            </div>
          </div>
          <Controller
            name='image'
            defaultValue={dashboardImage}
            render={({ field }) => {
              return (
                <ImagePicker
                  value={field.value}
                  clearImg={onClearImage}
                  onChange={(e) => {
                    field.onChange(e)
                    validateInputImage(e)
                  }}
                />
              )
            }}
          />
        </div>
        <Inputs name={'boardName'} label={'Dashboard Name'} unit={''} type='text' />
        <DashboardLink url={dashboardUrl} />
        {isAllowUpdateStatus && (
          <Switch
            name={'isActive'}
            label={'Dashboard Access'}
            description={'Allow customers to view the Dashboard via URL'}
            helperText={'When disabled, customers can not open the Dashboard via the link.'}
          />
        )}
      </div>
      <div className='btn-save' onClick={handleSubmit}>
        <div className='text'>Save</div>
      </div>
    </React.Fragment>
  )
}

export default AdminDashboardForm
